import React from 'react'
import { Box } from '@primer/react-brand'
import Header from './Header'
import Footer from './Footer'

const CenteredAuthLayout = ({ children, maxWidth = 360, membershipPath, signInPath, signUpPath, currentUser }) => {
  return (
    <Box style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header membershipPath={membershipPath} signInPath={signInPath} signUpPath={signUpPath} currentUser={currentUser} />
      <Box style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '48px 24px' }}>
        <div style={{ width: '100%', maxWidth: `${maxWidth}px` }}>
          {children}
        </div>
      </Box>
      <Footer />
    </Box>
  )
}

export default CenteredAuthLayout
